<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="home-box">
      <div>POSITE TECH PRIVATE LIMITED</div>
      <p>Green Future, Natural Choice</p>
    </div>
    <div class="home-2">
      <div class="home-2-info">
        <div class="sbtitle">LEARN ABOUT AGRICULTURE</div>
        <div class="title">THE GLOBAL IMPACT OF AGRICULTURE</div>
        <div class="text-1">Agricultural cultivation not only maintains ecological balance and environmental protection, but is also the key to achieving global food security and promoting economic growth.</div>
        <div class="text-img-box">
          <img src="../assets/home-11.png" class="home-img">
          <div class="info-box">
            <div>Ecological balance and environmental protection</div>
            <p>Agricultural cultivation promotes ecological diversity, helps maintain soil health, reduces greenhouse gas emissions, and provides important wildlife habitat, thereby maintaining global ecological balance..</p>
          </div>
        </div>
        <div class="text-img-box">
          <img src="../assets/home-12.png" class="home-img">
          <div class="info-box">
            <div>Food security and economic growth</div>
            <p>Agricultural cultivation is the cornerstone of ensuring global food security, supports world economic development, provides employment opportunities in rural areas, and promotes social stability and economic prosperity.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="home-3">
      <div class="h3-box">
        <div class="title-box">
          <div class="title">FRESH CROPS</div>
          <div class="title-text">Organic crops provide important contributions to human health and environmental sustainability</div>
        </div>
        <div class="item-box">
          <div class="item">
            <div class="item-img-box">
              <img src="../assets/home-6.png" class="item-img">
            </div>
            <div class="it-title">Enhance nutritional value</div>
            <div class="it-text">Organic crops contain higher levels of nutrients, including antioxidants, which help boost physical health and immunity.</div>
          </div>
          <div class="item">
            <div class="item-img-box">
              <img src="../assets/home-7.png" class="item-img">
            </div>
            <div class="it-title">Reduce chemical residue</div>
            <div class="it-text">Organic planting avoids the use of harmful chemicals, reduces the human body's intake of pesticide and chemical fertilizer residues, and reduces health risks.</div>
          </div>
          <div class="item">
            <div class="item-img-box">
              <img src="../assets/home-8.png" class="item-img">
            </div>
            <div class="it-title">Promote sustainable development</div>
            <div class="it-text">Organic farming supports ecological sustainability, reduces environmental pollution, promotes biodiversity, and generates long-term benefits for society and the environment.</div>
          </div>
          <div class="item">
            <div class="item-img-box">
              <img src="../assets/home-9.png" class="item-img">
            </div>
            <div class="it-title">Enhance community health</div>
            <div class="it-text">The production and consumption of organic crops encourages community participation and the development of local food systems, enhancing the overall health and well-being of the community.</div>
          </div>
        </div>
      </div>
    </div>

    <div class="img-list-box">
      <div class="sb-box">
        <div class="sb-title">CHECKOUT NEW PRODUCTS</div>
        <div class="title">SOME OF OUR PRODUCTS</div>
        <div class="list-box">
          <img src="../assets/home-16.png" alt="">
          <img src="../assets/home-17.png" alt="">
          <img src="../assets/home-18.png" alt="">
          <img src="../assets/home-19.png" alt="">
          <img src="../assets/home-20.png" alt="">
          <img src="../assets/home-21.png" alt="">
        </div>
      </div>
    </div>
    <div class="harvest">
      <p>JOY OF HARVEST</p>
      <div class="harvest-text">
        A bumper harvest brings not only a sense of fruitful accomplishment, but also a deep gratitude for nature's gifts. It symbolizes the rewards of hard work, the continuation of the cycle of life, and the shared prosperity and celebration of the community.
      </div>
    </div>

    <div class="achievement">
      <div class="sb-box">Achievement</div>
      <div class="title">Spreading value starts in 2020</div>
      <div class="a-list">
        <div class="item">
          <img src="../assets/home-13.png" alt="">
          <div class="one"></div>
          <div class="name">Happy Customers</div>
          <div class="number">190</div>
        </div>
        <div class="item">
          <img src="../assets/home-14.png" alt="">
          <div class="one"></div>
          <div class="name">New Products</div>
          <div class="number">500 +</div>
        </div>
        <div class="item">
          <img src="../assets/home-15.png" alt="">
          <div class="one"></div>
          <div class="name">Awards Winning</div>
          <div class="number">150 k</div>
        </div>
      </div>
    </div>


    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>


<style lang="less" scoped>
.home-box {
  // margin-top: 120px;
  background-image: url(../assets/home-1.png);
  background-size: 100% 100%;
  width: 100%;
  height: 700px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  div {
    font-size: 64px;
    font-family: Bebas;
    color: #FFFFFF;
    line-height: 85px;
  }

  p {
    width: 900px;
    font-size: 24px;
    font-weight: 600;
    color: #FFFFFF;
    margin-top: 32px;
  }
}

.home-2 {
  background-image: url(../assets/home-2.png);
  background-size: 100% 100%;
  width: 100%;
  height: 800px;
  display: flex;
  align-items: center;

  .home-2-info {
    // margin-top: 145px;
    margin-left: 945px;
    width: 815px;

    .sbtitle {
      font-size: 18px;
      font-weight: 600;
      color: #3E8359;
    }

    .title {
      font-size: 48px;
      font-family: Bebas;
      color: #333333;
      margin-top: 25px;
      font-weight: bold;
    }

    .text-1 {
      font-size: 18px;
      font-weight: 400;
      color: #999999;
      margin-top: 32px;
      margin-bottom: 10px;
    }

    .text-img-box {
      display: flex;
      align-items: center;
      margin-top: 19px;

      .home-img {
        width: 104px;
      }

      .info-box {


        div {
          font-size: 22px;
          font-weight: 600;
          color: #333333;
        }

        p {
          font-size: 18px;
          font-weight: 400;
          color: #999999;
          margin-top: 8px;
        }
      }
    }
  }
}

.home-3 {
  background-image: url(../assets/home-10.png);
  background-size: 100% 100%;
  width: 100%;
  height: 876px;

  .h3-box {
    padding: 98px 300px;

    .title-box {
      display: flex;
      align-items: center;

      .title {
        font-size: 48px;
        font-family: Bebas;
        color: #333333;
        font-weight: bold;
      }

      .title-text {
        font-size: 18px;
        font-weight: 400;
        color: #999999;
        width: 460px;
        margin-left: 48px;
      }
    }

    .item-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 100px;

      .item {
        width: 250px;
        height: 486px;
        background: #FFFFFF;
        padding: 30px;
        display: flex;
        align-items: center;
        flex-direction: column;

        .item-img-box {
          background-color: rgba(247, 195, 95, 1);
          border-radius: 50%;
          width: 150px;
          height: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;

          img {
            width: 150px;
          }
        }

        .it-title {
          font-size: 22px;
          font-weight: 600;
          color: #333333;
          margin-top: 25px;
        }

        .it-text {
          font-size: 18px;
          font-weight: 400;
          color: #999999;
          margin-top: 29px;
        }
      }
    }
  }
}

.img-list-box {
  width: 100%;
  min-height: 433px;
  background: #F9F4E8;

  .sb-box {
    padding: 60px 300px;
    text-align: center;

    .sb-title {
      font-size: 18px;
      font-weight: 600;
      color: #3E8359;
    }

    .title {
      font-size: 48px;
      font-family: Bebas;
      color: #333333;
      margin-top: 25px;
      font-weight: bold;
    }

    .list-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 80px;

      img {
        width: 200px;
      }
    }
  }
}

.harvest {
  background-image: url(../assets/home-3.png);
  background-size: 100% 100%;
  width: 100%;
  height: 700px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    font-size: 48px;
    font-family: Bebas;
    color: #333333;
    font-weight: bold;
    width: 446px;
    margin-left: 63px;
  }

  div {
    font-size: 18px;
    font-weight: 400;
    color: #999999;
    width: 446px;
    margin-left: 63px;
    margin-top: 21px;
  }
}

.achievement {
  padding: 120px 300px;
  text-align: center;

  .sb-box {
    font-size: 18px;
    font-weight: 600;
    color: #3E8359;
  }

  .title {
    font-size: 48px;
    font-family: Bebas;
    color: #333333;
    font-weight: bold;
    margin-top: 25px;
  }

  .a-list {
    margin-top: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .item {
      width: 320px;
      height: 280px;
      background: #FFFFFF;
      box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.06);
      padding: 25px 0px;
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;


      img {
        width: 64px;
      }

      .one {
        width: 2px;
        height: 50px;
        background: #3E8359;
        margin-top: 24px;
      }

      .name {
        font-size: 22px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #333333;
        margin-top: 15px;
      }

      .number {
        font-size: 48px;
        font-weight: 400;
        color: #333333;
        margin-top: 6px;
      }
    }
  }
}
</style>
